import React from 'react';
import CustomerAutoSyncSettings from './customersAutoSyncSettings';
import CustomerTagsSettings from './customerTagsSettings';

const Customers: React.FC = () => {

  return (
    <>
      <CustomerAutoSyncSettings />
      <CustomerTagsSettings />
    </>
  );
};

export default Customers;
